<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'BackgroundColorBoxToolDesktopButton',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'background',
      title: 'Background',
    };
  },
  methods: {
    action() {
      this.$emit('click');
    },
  },
};
</script>
